export interface AuthStatus {
  setupRequired: boolean;
  authenticated: boolean;
  mustResetPassword: boolean;
  username?: string;
  height_cm?: number | null;
  databaseCorrupt?: boolean;
}

export const AUTH_LOADING = 'AUTH_LOADING' as const;
export type AuthState = typeof AUTH_LOADING | AuthStatus;
